module.exports = __WEBPACK_EXTERNAL_MODULE__80694__;